export function flipper() {
    var flipperTitles = document.querySelectorAll('.flipper-title');
    var flippers = [];

    flipperTitles.forEach(function(flipperTitle) {
        var flipperTexts = flipperTitle.querySelectorAll('.flipper-title__flipper-text');
        var flipperContainer = flipperTitle.querySelector('.flipper-title__flipper');
        var currentIndex = 0;
        var intervalId;

        // Calculate and set the width of the flipper container
        function setFlipperWidth() {
            var maxWidth = 0;

            flipperTexts.forEach(function(text) {
                text.style.opacity = '0'; // Temporarily hide to measure width without affecting the layout
                var textWidth = text.offsetWidth;
                if (textWidth > maxWidth) {
                    maxWidth = textWidth;
                }
            });

            flipperContainer.style.width = maxWidth + 'px';

            // After measuring, revert all texts to opacity 0 except the first one
            flipperTexts.forEach(function(text, index) {
                if (index !== currentIndex) {
                    text.style.opacity = '0';
                    text.style.transform = 'rotateX(-90deg)';
                } else {
                    text.style.opacity = '1';
                    text.style.transform = 'rotateX(0deg)';
                }
            });
        }

        // Initialize the flipper text visibility and set the flipper width
        function initFlipper() {
            // Ensure the first text is visible immediately
            flipperTexts[currentIndex].style.opacity = '1';
            flipperTexts[currentIndex].style.transform = 'rotateX(0deg)';
            flipperTexts[currentIndex].classList.add('active');

            setFlipperWidth(); // Call this after making the first item visible
        }

        // Show the next flipper text with vertical rotation
        function showNextFlipperText() {
            // Remove 'active' class and hide the current text
            flipperTexts[currentIndex].classList.remove('active');
            flipperTexts[currentIndex].style.opacity = '0';
            flipperTexts[currentIndex].style.transform = 'rotateX(90deg)';

            currentIndex = (currentIndex + 1) % flipperTexts.length;

            // Show and animate the next text
            flipperTexts[currentIndex].style.opacity = '1';
            flipperTexts[currentIndex].style.transform = 'rotateX(0deg)';
            flipperTexts[currentIndex].classList.add('active');

            // If this flipper has completed a full rotation, reset all flippers to index 0
            if (currentIndex === 0) {
                resetAllFlippers();
            }
        }

        // Add this flipper's controls to the array
        flippers.push({
            setFlipperWidth,
            initFlipper,
            showNextFlipperText,
            resetIndex: function() {
                clearInterval(intervalId); // Stop the interval temporarily

                currentIndex = 0;

                // Ensure that all flipper texts are reset when the index is reset
                flipperTexts.forEach(function(text) {
                    text.classList.remove('active');
                    text.style.opacity = '0';
                    text.style.transform = 'rotateX(-90deg)';
                });

                // Immediately show the first text after reset
                flipperTexts[currentIndex].style.opacity = '1';
                flipperTexts[currentIndex].style.transform = 'rotateX(0deg)';
                flipperTexts[currentIndex].classList.add('active');

                // Restart the interval after resetting
                intervalId = setInterval(showNextFlipperText, 2000);
            }
        });

        // Initialize and start the flipper
        initFlipper();
        intervalId = setInterval(showNextFlipperText, 2000);
    });

    function resetAllFlippers() {
        flippers.forEach(function(flipper) {
            flipper.resetIndex();
        });
    }

    // Adjust flipper widths on window resize
    window.addEventListener('resize', function() {
        flippers.forEach(function(flipper) {
            flipper.setFlipperWidth();
        });
    });
}
